import {
  selectEmvOperationInProgress,
  selectEmvPaymentCancelInProgress,
  selectEmvPaymentReverseInProgress,
  selectEmvPaymentStartInProgress,
} from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-selectors';
import { createSelector } from 'reselect';
import {
  selectCartBySeatBlocks,
  selectcheckoutCart,
  selectRemovingSeatPlacedId,
  selectSuccessOrder,
} from 'containers/App/selectors';
import { selectIsOrderDeleteInProgress, selectOrderIdToRetry } from 'containers/EventDetailPage/selectors/main';
import { selectIsDeselectingSeat } from 'containers/EventDetailPage/selectors/seatStatus';
import { selectCheckoutInProgress } from './components/form/selectors';
import { selectIfShowEMVLoading } from './selectors';

export const selectCheckoutState = createSelector(
  [
    selectSuccessOrder,
    selectCartBySeatBlocks,
    selectOrderIdToRetry,
    selectIsDeselectingSeat,
    selectRemovingSeatPlacedId,
    selectcheckoutCart,
    selectIfShowEMVLoading,
    selectCheckoutInProgress,
    selectEmvOperationInProgress,
    selectEmvPaymentCancelInProgress,
    selectEmvPaymentReverseInProgress,
    selectIsOrderDeleteInProgress,
    selectEmvPaymentStartInProgress,
  ],
  (
    order,
    cart,
    orderIdToRetry,
    isDeselectingSeat,
    removingSeatPlacedId,
    checkoutCart,
    ifShowEMVLoading,
    isCheckoutInProgress,
    isEmvOperationInProgress,
    isEmvCancelInProgress,
    isEmvReverseInProgress,
    isOrderDeleteInProgress,
    isEmvPaymentStartInProgress,
  ) => ({
    order,
    checkoutSummaryData: cart || (order ? order.ticketsData : null),
    isCheckoutInProgress,
    isOrderUnpaid: !!orderIdToRetry,
    isDeselectingSeat,
    removingSeatPlacedId,
    checkoutCart,
    ifShowEMVLoading,
    isEmvOperationInProgress,
    isEmvCancelInProgress,
    isOrderDeleteInProgress,
    isEmvReverseInProgress,
    isEmvPaymentStartInProgress,
  }),
);
